<template>
  <div class="PageBox">
    <div class="ScrollBox">
		<van-nav-bar
		    fixed
		    :border="false"
		    :title="$t('lucky.default[2]')"
		    left-arrow
		    @click-left="$router.go(-1)"
		/>
		<div style="text-align:center" v-if="listData.length <= 0">{{$t("userLc.default[12]")}}</div>
		<div v-if="listData.length > 0">
		<van-cell  class="FundItem" :border="false" v-for="(item,index) in listData" :key="item.id">
			<template #title>
			  <div>
			    <span>{{item.order_number}}</span>
			    <span>{{item.time}}</span>
			  </div>
			  <div>
			    <span class="money">{{item.name}}</span>
			  </div>
			  <div>
				  <span>{{$t("lucky.default[10]")}}:{{item.end}}</span>
			  </div>
			</template>
		
		</van-cell>
		</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'luckyRecord',
  components: {
  },
  props: [],
  data() {
    return {
      listData: '',
      isLoad: false,
      isFinished: false,
      isRefresh: false,
      pageNo: 1,
    }
  },
  computed: {

  },
  watch: {

  },
  created() {
    this.$parent.navBarTitle = this.$t("lucky.default[2]")
    this.getListData('init')
  },
  mounted() {

  },
  activated() {

  },
  destroyed() {

  },
  methods: {
    onLoad() {
      this.getListData('load')
    },
    changeTabs(index) {

    },
    getListData(type) {
      this.isLoad = true
      this.isRefresh = false
      if(type=='load'){
        this.pageNo+=1
      }else{
        this.pageNo = 1
        this.isFinished = false
      }
       this.$Model.luckyRecord({userid:JSON.parse(localStorage.getItem("UserInfo")).userid},data=>{
            this.isLoad = false
            this.listData = data.info
        })

    },
    onRefresh() {
      this.getListData('init')
    },
  }
}
</script>
<style scoped>
.van-pull-refresh{
  min-height: calc(100vh - 90px);
}
</style>